module.exports = __webpack_public_path__ + "fonts/tt_sushkof_bold.f318ae9.woff2";